var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgSquare21D = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 60 60",
  ref: ref
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#464D57",
  d: "M11 9.404C11 8.076 12.063 7 13.375 7h33.25C47.937 7 49 8.076 49 9.404v20.192C49 30.924 47.937 32 46.625 32h-33.25C12.063 32 11 30.924 11 29.596V9.404Z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#646B75",
  fillRule: "evenodd",
  d: "M50.75 23.662A1 1 0 0 1 50 24H10a1 1 0 0 1-.992-1.124l2-16A1 1 0 0 1 12 6h36a1 1 0 0 1 .992.876l2 16a1 1 0 0 1-.242.786ZM47.117 8H12.883l-1.75 14h37.734l-1.75-14Z",
  clipRule: "evenodd"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fill: "#464D57",
  d: "M24.5 53a2.5 2.5 0 0 1-2.5-2.5v-11a2.5 2.5 0 0 1 2.5-2.5h11a2.5 2.5 0 0 1 2.5 2.5v11a2.5 2.5 0 0 1-2.5 2.5h-11Z"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  fill: "#646B75",
  fillRule: "evenodd",
  d: "M30 6a1 1 0 0 1 1 1v16a1 1 0 1 1-2 0V7a1 1 0 0 1 1-1ZM38.938 6.002a1 1 0 0 1 1.06.936l.998 16a1 1 0 1 1-1.996.124l-.998-16a1 1 0 0 1 .936-1.06ZM21.06 6.002a1 1 0 0 0-1.06.936l-.998 16a1 1 0 1 0 1.996.124l.998-16a1 1 0 0 0-.936-1.06Z",
  clipRule: "evenodd"
})), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  fill: "#BABCC0",
  fillRule: "evenodd",
  d: "M10 7a1 1 0 0 1 1-1h38a1 1 0 1 1 0 2H11a1 1 0 0 1-1-1Z",
  clipRule: "evenodd"
})));
SvgSquare21D.viewBox = '0 0 60 60';
const ForwardRef = /*#__PURE__*/forwardRef(SvgSquare21D);
export default ForwardRef;